import React from "react";
import WorkImg from "../assets/work.jpg";

const Work = () => {
  const works = [
    {
      name: "College Union",
      demo: "https://content-psi.vercel.app/",
      github: "https://github.com/joelwalice/content.git",
    },
    {
      name: "Akshaya Electricals",
      demo: "https://akshayahomeappliances.in/",
      github: "https://github.com/joelwalice/akshaya-electricals.git",
    },
    {
      name: "Digitrans Services",
      demo: "https://digitrans-web-dev.vercel.app/",
      github: "https://github.com/joelwalice/digitrans-web-dev.git",
    },
    {
      name: "V-Infinity Website",
      demo: "https://vinf-app-dnf3.vercel.app/",
      github: "https://github.com/joelwalice/vinf-app.git",
    },
    {
      name: "NextJS Quiz App",
      demo: "https://quiz-app-next-js-ecru.vercel.app/",
      github: "https://github.com/joelwalice/QuizApp-NextJS",
    },
    {
      name: "Inventory App",
      demo: "https://inventory-kappa-plum.vercel.app/",
      github: "https://github.com/joelwalice/Inventory-Management",
    },
    
  ];

  return (
    <div name="work" className="w-full md:h-screen text-gray-200 m-4">
      <div className="max-w-[1000px] mx-auto my-8 p-4 flex flex-col justify-center w-full h-full">
        <div className="pb-8">
          <p className="text-4xl md:text-5xl font-bold inline border-b-4 text-gray-200 border-red-600">
            <br></br>
            <br></br>Work
          </p>
          <p className="py-3 mt-5">
            --&gt; These are my works below. Hover for the code and Demo 👇
          </p>
        </div>
        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-4 mb-[100px] cursor-pointer">
          {works.map((work, index) => (
            <div
              key={index}
              style={{ backgroundImage: `url(${WorkImg})` }}
              className="shadow-lg shadow-[#040c16] group container rounded-md flex justify-center items-center mx-auto content-div"
            >
              <div className="opacity-0 group-hover:opacity-100">
                <span className="text-2xl font-bold text-white tracking-wider">
                  {work.name}
                </span>
                <div className="pt-8 text-center">
                  <a href={work.demo} target="_blank" rel="noopener noreferrer">
                    <button className="text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg">
                      DEMO
                    </button>
                  </a>
                  <a
                    href={work.github}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <button className="text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg">
                      CODE
                    </button>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Work;
